export default __webpack_public_path__ + "d47d6da0c68ab99eb382572fdf76a319.png";